<template>
   <div class="withdrawal" v-loading.fullscreen.lock="loading">
       <breadcrumb :breadcrumb="crumbList"></breadcrumb>
       <div class="withdrawal_box">

           <div class="withdrawal_box_title">余额提现</div>
           <el-form class="withdrawal_box_form" label-width="100px">
               <el-form-item label="银行卡：">
                    <el-select v-model="form.card_id" style="width:100%" placeholder="请选择银行卡号">
                        <el-option
                        v-for="item in cardList"
                        :key="item.id"
                        :label="item.card_no"
                        :value="item.id">
                            <span style="float: left">{{ item.card_no }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.bank }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
               <el-form-item label="提现金额：" class="withdrawal_input">
                    <el-input v-model="form.money" placeholder="请输入提现金额"></el-input>
                    <span class="withdrawal_input_unit">元</span>
                    <div class="withdrawal_input_msg">
                        <div style="padding-left:10px">可提现余额 {{userData.money}}元<el-button type="text" style="margin-left:10px" @click="form.money = userData.money">全部提现</el-button></div>
                        <div style="padding-left:10px">收取手续费2元/笔</div>
                        <div style="margin-top:16px">验证当前绑定账号 {{userData.phone | phoneFormat}}</div>
                    </div>
                    
                </el-form-item>
                <el-form-item label="验证码：">
                    <el-input v-model="form.sms_code" style="width:184px" placeholder="请输入验证码"></el-input>
                    <el-button v-if="num == 0" type="primary" class="withdrawal_box_from_code" style="width:106px" @click="getCode">获取验证码</el-button>
                    <div class="withdrawal_box_from_code1" v-else>已发送/{{num}}s</div>
                </el-form-item>
                <el-form-item class="withdrawal_box_from_item">
                    <el-button class="" type="primary" @click="submit">立即提现</el-button>
                </el-form-item>

           </el-form>
       </div>
   </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb'
export default {
   data (){
       return {
           crumbList:[
               {name:'个人中心',path:'/message'},
               {name:'我的钱包',path:'/wallet'},
               {name:'余额提现'}
           ],
           form:{
               card_id:'',
               money:'',
               sms_code:''
           },
           value:'',
           options:[],
           userMessage:JSON.parse(localStorage.getItem('userMessage') || '{}'),
           userData:{},
           cardList:[],
           num:0,
           loading:false
       }
   },
   components: {
       breadcrumb
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       submit(){
           if(!this.form.money){
               this.$message.error('请输入提现金额'); return;
           } 
           if(!this.form.sms_code){
               this.$message.error('请输入验证码'); return;
           } 
           if(!this.form.card_id){
               this.$message.error('请选择提现银行卡'); return;
           } 
           if(parseFloat(this.userData.money) < parseFloat(this.form.money)){
               this.$message.error('提现金额大于可提现金额！');
               return
           }
           this.loading = true;
           this.$post('Cashout',this.form)
            .then(data => {
                this.loading = false;
                this.$message.success('提现成功');
                
            } , error => {
                this.loading = false;
                this.$message.error(error);
            });
       },
       getUserInfo(){
           this.$get('userInfo' , {})
            .then(data => {
                this.userData = data;
            } , error => {
                this.$message.error(error);
            });
       },
       getCardList(){
           this.$get('BankCard',{page_index:1,page_size:9999})
            .then(data => {
                let cardList = data.data;
                _.each(cardList , item => {
                    item.card_no = item.bank_card_no_before + '*********' + item.bank_card_no;
                });
                this.cardList = cardList;
            } , error => {
                this.$message.error(error);
            });
       },
       getCode(){
            // this.$post('SendSmsCode',{mobile:this.userData.phone})
            //     .then(data => {
                    this.num = 59;
                    let timer = setInterval(()=> {
                        this.num --;
                        if(this.num == 0){
                            clearInterval(timer);
                        }
                    },1000);
                // } , error => {
                //     this.$message.error(error);
                // });
        },
   },
   created() {
       this.getUserInfo();
       this.getCardList();
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.withdrawal{
    padding:0 20px ;
    &_input{
        position: relative;
        /deep/ .el-input__inner{
            padding-right: 46px;
        }
        &_unit{
            position: absolute;
            top:0;
            right:16px;
            color:#333333;
        }
        &_msg{
            div{
                line-height: 24px;
                font-size: 14px;
                color:#999999;
            }
            /deep/ .el-button{
                padding: 0;
            }
        }
    }
    &_box{
        margin-top:20px;
        &_title{
            font-size: 20px;
            font-weight: 500;
            color:#333;
            padding: 20px 0;
        }
        &_form{
            width:400px;
            &_explain{
                display: flex;
                align-items: center;
                justify-content:flex-end;
                img{
                    width:20px;
                    height: 20px;
                }
                span{
                    font-size: 14px;
                    color:#999999;
                }
            }
            &_card{
                display: flex;
                justify-content:space-between;
                img{
                    width:154px;
                    height: 112px;
                    cursor: pointer;
                }
                
            }
            .withdrawal_box_from_code1{
                display: inline-block;
                width:106px;
                font-size: 16px;
                line-height: 36px;
                text-align: right;
                color:#999999;
            }
            /deep/ .withdrawal_box_from_code.el-button{
                height: 36px;
                padding: 10px 16px;
                margin-left: 5px;
            }
            /deep/ .el-form-item{
                margin-bottom:18px;
            }
            /deep/ .el-input__inner{
                border-radius: 0px;
                height: 36px;
                line-height: 36px;
            }
            /deep/ .el-form-item__label{
                color:#666;
                font-size: 16px;
                font-weight: 400;
            }
            /deep/ .withdrawal_box_from_item.el-form-item{
                margin-bottom:8px;
                .el-button{
                    width:100%;
                    font-size: 18px;
                    font-weight: 400;
                    background: #1F9EFF;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/wallet/withdrawal.vue